import { DocumentText, IconProps } from 'grommet-icons';

export const StatementIcon: React.FC<IconProps> = (props) => <DocumentText size="24px" color="brand" {...props} />;
